export enum PromoCodeStatus {
  Enabled = 'Enabled',
  Disabled = 'Disabled',
  Expired = 'Expired',
}
